<template>
  <div class="play">
    <back-current
      v-if="appVersion === 'dd'"
      :title="activeInfo.eventInfo ? activeInfo.eventInfo.eventName : ''"
    ></back-current>
    <div class="video-container" id="videoContainer" :class="{fullScreen: video.isFullScreen}">
      <!-- 录播 -->
      <video
        v-show="!video.isLive"
        id="videoElement"
        x5-video-player-type="h5-page"
        playsinline
        webkit-playsinline
      ></video>
      <!-- 直播- -->
      <video v-show="video.isLive" playsinline webkit-playsinline id="mainVideoElement"></video>
      <div class="screen liveBullet"></div>
      <div class="screen videoBullet"></div>
      <!-- 水印 -->
      <template v-if="video.liveisPlaying">
        <div v-for="(water, index) in waterList" :style="{...water}" :key="index" class="water-item">
          <img :src="$isCdn(water.path)" style="width: 100%; height: 100%" alt="" />
        </div>
      </template>
      <!-- 水印 -->
      <!-- 直播 -->
      <live-screen
        v-if="video.isLive"
        @startPlay="liveStart2Play"
        @previewVideofirst="previewVideofirst"
        @restScreen="restScreen"
      />
      <!-- 录播-screen -->
      <video-screen
        :videoDuration="videoDuration"
        :videoCurrent="videoCurrent"
        v-else
        @videoPlayOrPause="videoPlayOrPause"
        @videoCurrentTimeChange="videoCurrentTimeChange"
        @restScreen="restScreen"
      ></video-screen>
    </div>
    <div class="head" :class="{subVideoActive}">
      <!-- 选人 -->
      <div v-show="showSelectPerson" class="person-select">
        <img v-if="userInfo.userFace" :src="$isCdn(userInfo.userFace)" alt="" />
        <img v-else src="@/assets/image/avatar.svg" alt="" />
        <span class="txt">{{ userInfo.name }}，你被选中啦!</span>
        <i @click="showSelectPerson = false" class="iconfont icon-close"></i>
      </div>
      <!-- 选人 -->
      <div
        @dblclick="handledbChangeVideo"
        @click="handleChangeVideoUrl"
        v-if="video.doubleUrl"
        class="sub-video-container"
      >
        <video muted playsinline webkit-playsinline id="subVideoElement"></video>
        <div class="top-mask" v-if="!video.showSubScreen">
          <span class="ab-center">画面已关闭</span>
        </div>
      </div>
      <div class="active-info-container">
        <div class="title-container">
          <div class="title van-ellipsis">{{ activeInfo.eventInfo ? activeInfo.eventInfo.eventName : '' }}</div>
          <div v-clickOutside="handleHideMoreBtnDetail" @click="showMoreBtnDetail = true" class="more-btn">
            <i style="color: #303133" class="iconfont icongengduo-sidian"></i>

            <div v-show="showMoreBtnDetail" class="more-btn-detail">
              <div class="good">
                <van-icon @click.stop="handleGood" v-if="!action.showGood" name="good-job" />
                <van-icon v-else color="#4D86EE" name="good-job" />
                <small>{{ action.good }}</small>
              </div>
              <div class="grade">
                <van-icon @click.stop="handleShowGradePanel" v-if="!action.showGrade" name="star" />
                <van-icon v-else color="#F7BC1D" name="star" />
                <small>{{ action.grade }}</small>
              </div>
              <span @click.stop="handleShowDetail">详情</span>
            </div>
          </div>
        </div>
        <div class="tab">
          <div class="tab-container">
            <span @click="changeTab(0)" :class="{active: tabIndex === 0}">直播</span>
            <span @click="changeTab(1)" :class="{active: tabIndex === 1}">录像</span>
            <span @click="changeTab(2)" :class="{active: tabIndex === 2}">附件</span>
            <span @click="changeTab(3)" :class="{active: tabIndex === 3}">评论</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-container">
      <!-- 公告 -->
      <div v-show="notice.show" class="Notice">
        <i @click="notice.show = false" class="iconfont icon-close"></i>
        <div class="title">公告</div>
        <div class="value">{{ notice.value }}</div>
      </div>
      <!-- 公告 -->
      <template v-if="tabIndex === 0">
        <web-chat :ws="ws" :chatList="chatList" />
      </template>
      <div v-if="tabIndex === 1" style="height: 100%">
        <!-- <web-content @on-previewVideo="previewVideo" /> -->
        <videos ref="videoContent" :videoBullet="videoBullet" :isWenxuan="isWenxuan" @on-previewVideo="previewVideo" />
      </div>
      <template v-if="tabIndex === 2">
        <attrs />
      </template>
      <template v-if="tabIndex === 3">
        <leave-msg />
      </template>
    </div>
    <!-- 视频设置 -->
    <video-panel />
    <!-- 评分 -->
    <rate-panel />
    <!-- 活动详情 -->
    <detailPanel />
    <!-- 评课 -->
    <course />
    <!-- 签到 -->
    <sign />
    <!-- 验证 -->
    <check />
    <!-- 引导页 -->
    <guide />
    <!-- 快速答题 -->
    <answer />
    <answerBar v-if="tabIndex === 0 || tabIndex === 1" />
    <!-- <Back /> -->
    <videoscreenfullcontrol
      :videoDuration="videoDuration"
      :videoCurrent="videoCurrent"
      @videoCurrentTimeChange="videoCurrentTimeChange"
      @videoPlayOrPause="videoPlayOrPause"
      @restScreen="restScreen"
    />
  </div>
</template>

<script>
import flvjs from 'flv.js'
// import BulletJs from './../../../public/BulletJs.min.js'
// import Bullet from 'js-bullets'
import dingtalk from 'dingtalk-jsapi'
import {BulletJs} from '@/ultis/BulletJs'
import {getIsIOS} from '@/ultis'
import {getEventAuth, saveLookAction, saveEventAction, getUser, getUserIpLocation} from '@/api'
// eslint-disable-next-line no-unused-vars
import {wsMixin} from './wsMixin'
import _ from 'lodash'
export default {
  name: 'ysEvent',
  mixins: [wsMixin],
  components: {
    backCurrent: () => import('./../../components/back-current.vue'),
    webChat: () => import('./chat'),
    leaveMsg: () => import('./content_leaveMsg'),
    attrs: () => import('./content_attrs'),
    videos: () => import('./content_videos'),
    // webContent: () => import('./content'),
    videoPanel: () => import('./panel/videoPanel'),
    ratePanel: () => import('./panel/ratePanel'),
    detailPanel: () => import('./panel/detailPanel'),
    videoScreen: () => import('./videoScreen'),
    liveScreen: () => import('./liveScreen'),
    course: () => import('./course'),
    sign: () => import('./sign'),
    check: () => import('./check'),
    guide: () => import('./guide'),
    answer: () => import('./quickAnswer/answerPanel.vue'),
    answerBar: () => import('./quickAnswer'),
    videoscreenfullcontrol: () => import('./videoscreenfullcontrol.vue')
  },
  data() {
    const isIOS = getIsIOS()
    return {
      lookTime: 0,
      isIOS,
      id: this.$route.params.id,
      tabIndex: 0, // 0 直播 1内容
      /* webChat */
      ws: null,
      chatList: [],
      barrageList: [],
      clonedBarrageList: [],
      /* 主视频状态 */
      subVideoActive: false, // 副视频变大
      changeStatusIndex: 1, // 主副视频交换

      /* 录播 */
      videoDuration: 0,
      videoCurrent: 0,

      /* 选人 */
      showSelectPerson: false,
      /* 公告 */
      notice: {
        value: '',
        show: false
      },
      liveBullet: null,
      videoBullet: null,
      showMoreBtnDetail: false,

      waterList: [],

      debounce: true,
      isWenxuan: 0
    }
  },
  watch: {
    lookTime(time) {
      if (this.checkInfo.isOpen && time % this.checkInfo.randomTime === 0) {
        /* 开启验证、暂停/开启视频 */
        this.videoPauseOrPlayForCheck(false)
        this.$store.commit('setCheckInfo', {
          showCheckModal: true
        })
      }
    },
    activeInfo(val) {
      if (val && val.watermarks && val.watermarks.length > 0) {
        this.initWaters()
      }
    }
  },
  computed: {
    checkInfo() {
      return this.$store.state.activePlay.checkInfo
    },
    video() {
      return this.$store.state.activePlay.video
    },
    /* 点赞 */
    action() {
      return this.$store.state.activePlay.action
    },
    /* 活动基础信息 */
    activeInfo() {
      return this.$store.state.activePlay.activeInfo
    },
    isFullScreen() {
      return this.$store.state.activePlay.isFullScreen
    },
    /* user信息 */
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.pass) {
      return next()
    }
    getEventAuth(to.params.id).then(({data}) => {
      const {auth, authType} = data
      if (auth) {
        next()
      } else {
        if (!localStorage.getItem('Authorization')) {
          next({path: `/login?redirect=${encodeURIComponent(location.href)}`})
        }
        if (authType === 2) {
          /* 密码 */
          next({path: `/validPwd/${to.params.id}`, replace: true})
        } else if (authType === 1) {
          /* 登录观看 */
          next({path: `/login?redirect=${encodeURIComponent(location.href)}`})
        } else {
          next({path: '/401', replace: true})
        }
      }
    })
  },
  async created() {
    const {data} = await getUser()
    if (data) {
      this.$store.commit('setUser', data)
    }
    this.$store.dispatch('getAuth', this.id)
    this.$store.dispatch('fetchLiveUrls', this.id)
    this.$store.dispatch('getActiveInfo', this.id)
    this.$store.dispatch('getComments', this.id)
    this.isWenxuan = Number(this.$route.query.isWenxuan) || 0
  },
  mounted() {
    this.getUserIpLocation()
    this.mainVideoElement = document.getElementById('mainVideoElement')
    this.videoElement = document.getElementById('videoElement')
    this.mainVideoElement.addEventListener('play', () => {
      this.$store.commit('controlVideo', {liveisPlaying: true, videoisPlaying: false, isLive: true})
    })
    this.mainVideoElement.addEventListener('pause', () => {
      this.$store.commit('controlVideo', {liveisPlaying: false})
    })
    this.mainVideoElement.addEventListener('timeupdate', () => {
      /* 未开启验证 */
      if (!this.checkInfo.isOpen) return
      if (this.mainVideoTimer) return
      this.mainVideoTimer = setTimeout(() => {
        this.lookTime += 1
        this.mainVideoTimer = null
      }, 1000)
    })
    // 如果直播流中断后触发
    this.mainVideoElement.addEventListener('waiting', async () => {
      console.log('Wait! ')
      if (this.debounce) {
        // 重新启动直播
        this.mainVideoElement.src = ''
        this.mainVideoElement.pause()
        await this.$store.dispatch('fetchLiveUrls', this.id)
        this.liveStart2Play()
        this.debounce = false
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.debounce = true
        }, 7000)
      }
    })

    this.videoElement.addEventListener('play', () => {
      this.$store.commit('controlVideo', {liveisPlaying: false, videoisPlaying: true, isLive: false, doubleUrl: false})
    })
    this.videoElement.addEventListener('pause', () => {
      this.$store.commit('controlVideo', {liveisPlaying: false, videoisPlaying: false, isLive: false})
    })
    this.videoElement.addEventListener('ended', () => {
      this.$store.commit('controlVideo', {liveisPlaying: false, videoisPlaying: false, isLive: false})
    })
    this.videoElement.addEventListener('canplay', e => {
      this.$store.commit('controlVideo', {videoisLoading: false, isLive: false})
    })
    this.videoElement.addEventListener('loadedmetadata', e => {
      this.videoDuration = e.target.duration
    })
    this.videoElement.addEventListener('timeupdate', e => {
      this.videoCurrent = e.target.currentTime
      this.filterDanmu(this.videoElement.currentTime)
    })
    this.liveBullet = new BulletJs('.liveBullet', {
      trackHeight: 35
    })
    this.videoBullet = new BulletJs('.videoBullet', {
      trackHeight: 35
    })
  },
  methods: {
    /* 获取当前 IP 定位信息 */
    getUserIpLocation() {
      getUserIpLocation({eventId: this.id})
        .then(res => {
          console.log('IP 定位信息：', res)
        })
        .catch(() => {})
    },
    /* 生成水印 */
    initWaters(type) {
      const watermarks = this.activeInfo.watermarks
      if (!watermarks || !watermarks.length) return
      const videoContainer = document.getElementById('videoContainer')
      const {width, height} = videoContainer.getBoundingClientRect()
      const maxWidth = String(watermarks[0].ratio).split('.')[0]
      const maxHeight = String(watermarks[0].ratio).split('.')[1]
      const list = []
      watermarks.forEach(item => {
        let target = {
          position: 'absolute',
          path: item.path,
          zIndex: 98
        }
        target = {
          ...target,
          width: (width / maxWidth) * item.width + 'px',
          height: (height / maxHeight) * item.height + 'px',
          left: (width / maxWidth) * item.leftX + 'px',
          top: (height / maxHeight) * item.leftY + 'px'
        }
        if (type) {
          target = {
            ...target,
            width: (width / maxHeight) * item.height + 'px',
            height: (height / maxWidth) * item.width + 'px',
            top: (width / maxHeight) * item.leftY + 'px',
            left: (height / maxWidth) * item.leftX + 'px'
          }
        }
        list.push(target)
      })
      this.waterList = list
    },
    /* 生成水印 */
    /* 切换全屏 \ 重置弹幕屏幕 */
    restScreen(isFullScreen) {
      const liveBullet = document.querySelector('.liveBullet')
      const videoBullet = document.querySelector('.videoBullet')
      videoBullet.innerHTML = ''
      liveBullet.innerHTML = ''
      this.liveBullet = null
      this.videoBullet = null
      this.$nextTick(() => {
        this.initWaters(isFullScreen ? true : '')

        if (isFullScreen) {
          const dom = document.querySelector('.screen')
          if (!dom) return
          const targetPos = dom.getBoundingClientRect()
          const newPos = {
            x: targetPos.x,
            y: targetPos.y,
            width: targetPos.width,
            height: targetPos.height,
            left: targetPos.left,
            top: targetPos.top,
            right: targetPos.right,
            bottom: targetPos.bottom
          }
          if (isFullScreen) {
            newPos.width = targetPos.height
            newPos.height = targetPos.width
          }

          this.liveBullet = new BulletJs(
            '.liveBullet',
            {
              trackHeight: 35
            },
            newPos
          )
          this.videoBullet = new BulletJs(
            '.videoBullet',
            {
              trackHeight: 35
            },
            newPos
          )
        } else {
          this.liveBullet = new BulletJs('.liveBullet', {
            trackHeight: 35
          })
          this.videoBullet = new BulletJs('.videoBullet', {
            trackHeight: 35
          })
        }
      })
    },
    /* 全屏遇到可操作时 退出全屏 */
    cancelFullScreen() {
      if (this.isFullScreen) {
        this.restScreen(false)
        this.initWaters()
        const mainPlayerContainer = document.getElementById('videoContainer')
        mainPlayerContainer.style.width = ''
        mainPlayerContainer.style.height = ''
        mainPlayerContainer.style.zIndex = ''
        mainPlayerContainer.style.transform = ''
        this.$store.commit('toggleFullScreen')
      }
    },
    /* 点赞 */
    handleGood() {
      if (this.userInfo.id) {
        this.$store.dispatch('handleGood', this.id)
      } else {
        this.$dialog
          .alert({
            closeOnClickOverlay: true,
            theme: 'round-button',
            confirmButtonColor: '#4465f3',
            message: '您没有登录,去登录?'
          })
          .then(() => {
            this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
          })
      }
    },
    handleShowGradePanel() {
      if (this.userInfo.id) {
        this.$store.commit('controlPanel', {showRate: true})
      } else {
        return this.$dialog
          .alert({
            closeOnClickOverlay: true,
            theme: 'round-button',
            confirmButtonColor: '#4465f3',
            message: '您没有登录,去登录?'
          })
          .then(() => {
            this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
          })
      }
    },
    handleShowDetail() {
      this.$store.commit('controlPanel', {showDetail: true})
    },

    receiveMsg({data}) {
      // console.log(data)
      // 接收数据
      const msg = JSON.parse(data)
      /* 聊天 */
      if (msg.c === 1000) {
        let talkInfo = msg.d.m
        talkInfo = talkInfo.replace(/{emoji:(\d+)}/gi, function(index) {
          // eslint-disable-next-line no-unused-vars
          const [num] = index.match(/\d+/g)
          const img = require(`@/assets/image/emoji/${num}.png`)
          // eslint-disable-next-line no-undef
          return `<img style="width:18px;height:18px;vertical-align: middle;" src=${img}>`
        })
        const obj = {
          color: msg.d.color,
          talkInfo,
          talkManName: msg.d.n,
          avatar: msg.d.f
        }
        this.chatList.push(obj)
        if (this.video.isLive && this.video.liveisPlaying) {
          if (obj.avatar) {
            this.liveBullet &&
              this.liveBullet.push(`
          <div class="bullet-item">
            <img src="${this.$isCdn(obj.avatar)}">
            <span style="color:${obj.color}">${obj.talkManName}:</span>
            <span style="color:${obj.color}">${talkInfo}</span>
          </div>`)
          } else {
            this.liveBullet &&
              this.liveBullet.push(`
          <div class="bullet-item">
            <img src="${require('@/assets/image/user.png')}">
            <span style="color:${obj.color}">${obj.talkManName}:</span>
            <span style="color:${obj.color}">${talkInfo}</span>
          </div>`)
          }
        }
      }
      /* 签到 */
      if (msg.c === 20000) {
        this.cancelFullScreen()
        this.$store.commit('setSignInfo', {
          showSignBtn: true,
          showSignModal: true,
          time: msg.s.time * 1000
        })
      }
      if (msg.c === 20001) {
        this.$store.commit('setSignInfo', {
          showSignBtn: false,
          showSignModal: false
        })
      }
      /* 验证 */

      /* 验证开启、关闭 ====> 重置记录观看时间 */
      if (msg.c === 20002) {
        const {start, end, openStatus} = msg.s
        const validationBegin = start
        const validationEnd = end
        const isOpen = openStatus === 1
        const randomTime = Math.floor(
          Math.random() * (validationEnd * 60 - validationBegin * 60) + validationBegin * 60
        )

        this.lookTime = 0
        this.$store.commit('setCheckInfo', {
          isOpen,
          randomTime
        })
      }
      /* 答题 停止答题 */
      if (msg.c === 30001) {
        const {objectId, objectType, stop} = msg.a
        // objectType 2 快速答题  1 标准答题
        // 有stop 就是关闭
        if (!stop) {
          this.cancelFullScreen()
        }
        this.$store.commit('setAnswerInfo', {
          showTip: !stop,
          showPanel: !stop,
          objectType,
          objectId
        })
      }
      /* 选人 */
      if (msg.c === 40001) {
        const selectedPersons = msg.u || []
        // this.$store.commit('setRadomPersons', selectedPersons)
        const userId = this.userInfo.id || ''
        const isYou = selectedPersons.find(item => item.i === userId)
        if (isYou) {
          this.cancelFullScreen()
          this.showSelectPerson = true
        }
      }
      /* 公告 */
      if (msg.c === 1111) {
        this.cancelFullScreen()
        const value = msg.d.m
        if (value) {
          this.notice = {
            value,
            show: true
          }
        }
      }
    },
    /* ws */
    // liveStart2Play
    liveStart2Play() {
      const isDoubleLive = this.video.doubleUrl
      if (!this.video.urlList.length) return

      const Index1 = this.changeStatusIndex === 1 ? 0 : 1
      const Index2 = this.changeStatusIndex === 1 ? 1 : 0

      if (this.isIOS) {
        if (isDoubleLive) {
          this.subVideoElement = document.getElementById('subVideoElement')
          this.subVideoElement.src = this.video.urlList[Index2].phoneUrl
        }
        this.mainVideoElement.src = this.video.urlList[Index1].phoneUrl
        this.mainVideoElement.play()
        this.subVideoElement && this.subVideoElement.play()
      } else {
        let flag = false
        dingtalk.ready(() => {
          flag = true
          if (isDoubleLive) {
            this.subVideoElement = document.getElementById('subVideoElement')
            this.subVideoElement.src = this.video.urlList[Index2].phoneUrl
            this.subVideoElement.play()
          }
          this.mainVideoElement.src = this.video.urlList[Index1].phoneUrl
          this.mainVideoElement.play()
        })
        if (!flag) {
          if (isDoubleLive) {
            this.subVideoElement = document.getElementById('subVideoElement')
            this.getStream('subMainPlayer', this.video.urlList[Index2].flvUrl, this.subVideoElement)
          }
          this.getStream('mainPlayer', this.video.urlList[Index1].flvUrl, this.mainVideoElement)
        }
      }
      /* 记录 */
      if (!this.userInfo.id) return
      saveEventAction({
        actionDevice: 2,
        eventActionType: 5,
        eventInfoId: this.id
      })
      const params = {
        attrId: '',
        deviceType: 2,
        eventId: this.id,
        lookType: 1 // 1. 直播 2. 点播
      }
      saveLookAction(params).then(res => {
        this.$store.commit('setLookActionId', res.data)
      })
    },
    getStream(instance, url, element) {
      if (flvjs.isSupported()) {
        this[instance] = flvjs.createPlayer({
          type: 'flv',
          isLive: true,
          url
        })
        this[instance].attachMediaElement(element)
        this[instance].load()
        this[instance].play()
        this[instance].on(flvjs.Events.ERROR, (errorType, errorDetail, errorInfo) => {
          console.log(errorType)
        })
      }
    },
    videoCurrentTimeChange(value) {
      console.log('videoCurrentTimeChange')
      this.videoElement.currentTime = value
      this.barrageList = _.cloneDeep(this.clonedBarrageList)
    },
    /* 验证视频暂停 */
    videoPauseOrPlayForCheck(flag) {
      /* true ===> play  false ===> pause */
      if (this.video.isLive) {
        /* 直播 */
        if (flag) {
          this.liveStart2Play()
        } else {
          this.liveDestroy()
          this.$store.commit('controlVideo', {liveisPlaying: false, videoisPlaying: false, isLive: true})
        }
      } else {
        /* 视频 */
        this.videoPlayOrPause(flag)
      }
    },
    /* video↑ */
    async changeTab(tabIndex) {
      /* 切换隐藏 */
      if (this.tabIndex === 0 && tabIndex === 1) {
        const liveBullet = document.querySelector('.liveBullet')
        const videoBullet = document.querySelector('.videoBullet')
        videoBullet.innerHTML = ''
        liveBullet.innerHTML = ''
      }
      if (this.tabIndex === 1 && tabIndex === 0) {
        const liveBullet = document.querySelector('.liveBullet')
        const videoBullet = document.querySelector('.videoBullet')
        videoBullet.innerHTML = ''
        liveBullet.innerHTML = ''
      }

      this.tabIndex = tabIndex
      this.subVideoActive = false
      if (tabIndex === 0 && !this.video.isLive) {
        this.$store.commit('setVideoDanmuSet', {
          attrId: ''
        })
        /* 重启直播 */
        this.videoElement.src = ''
        this.videoElement.pause()
        await this.$store.dispatch('fetchLiveUrls', this.id)
        this.liveStart2Play()
      }
    },
    handledbChangeVideo() {
      clearTimeout(this.dbTimer)
      this.subVideoActive = !this.subVideoActive
    },
    handleChangeVideoUrl() {
      clearTimeout(this.dbTimer)
      this.dbTimer = setTimeout(() => {
        const Index1 = this.changeStatusIndex === 1 ? 1 : 0
        const Index2 = this.changeStatusIndex === 1 ? 0 : 1
        this.mainVideoElement.pause()
        this.subVideoElement.pause()
        if (this.isIOS) {
          this.mainVideoElement.src = this.video.urlList[Index1].phoneUrl
          this.subVideoElement.src = this.video.urlList[Index2].phoneUrl
          this.mainVideoElement.play()
          this.subVideoElement.play()
        } else {
          this.mainPlayer.destroy()
          this.subMainPlayer.destroy()
          this.getStream('mainPlayer', this.video.urlList[Index1].flvUrl, this.mainVideoElement)
          this.getStream('subMainPlayer', this.video.urlList[Index2].flvUrl, this.subVideoElement)
        }
        this.changeStatusIndex = this.changeStatusIndex === 1 ? 0 : 1
      }, 300)
    },
    liveDestroy() {
      this.mainVideoElement && this.mainVideoElement.pause()
      this.subVideoElement && this.subVideoElement.pause()
      if (this.mainPlayer) {
        this.mainPlayer.destroy()
        this.mainPlayer = null
      }
      if (this.subMainPlayer) {
        this.subMainPlayer.destroy()
        this.subMainPlayer = null
      }
    },
    previewVideofirst() {
      this.tabIndex = 1
      setTimeout(() => {
        const videoContent = this.$refs.videoContent
        videoContent.handle2Preview(videoContent.videoList[0])
      }, 1000)
      // this.$nextTick(() => {
      // })
    },
    /* 视频预览 */
    previewVideo({eventAttrPath, eventAttrId, eventAttrType, barrageList}) {
      this.tabIndex = 1
      this.barrageList = _.cloneDeep(barrageList)
      this.clonedBarrageList = _.cloneDeep(barrageList)
      this.videoElement.pause()
      const videoBullet = document.querySelector('.videoBullet')
      videoBullet.innerHTML = ''
      /* ssssss */
      /* ssssss */
      this.subVideoActive = false
      this.liveDestroy()
      this.$store.commit('controlVideo', {videoisLoading: true, isLive: false})
      this.eventAttrId = eventAttrId
      this.videoElement.src = eventAttrPath
      this.videoElement.play()

      /* ==观看记录== */
      if (!this.userInfo.id) return
      saveLookAction({
        attrId: eventAttrId,
        deviceType: 2,
        eventId: this.id,
        lookType: 2 // 1. 直播 2. 点播
      }).then(res => {
        this.$store.commit('setLookActionId', res.data)
      })
      if (eventAttrType === 6) {
        saveEventAction({
          actionDevice: 2,
          eventActionType: 6,
          eventInfoId: this.id
        })
      }
    },
    videoPlayOrPause(flag) {
      if (flag) {
        this.videoElement.play()
      } else {
        this.videoElement.pause()
      }
    },
    filterDanmu(currentTime) {
      console.log(currentTime)
      if (currentTime === 0) return

      const filterDanmu = []
      for (let i = 0; i < this.barrageList.length; i++) {
        const item = this.barrageList[i]
        if (Math.abs(currentTime - item.eventAttrTime) < 0.25) {
          filterDanmu.push(item)
          this.barrageList.splice(i, 1)
        }
      }

      // const filterDanmu = []
      // for (let i = this.barrageList.length - 1; i > 0; i--) {
      //   const item = this.barrageList[i]
      //   if (Math.abs(currentTime - item.eventAttrTime) < 0.25) {
      //     filterDanmu.push(item)
      //     this.barrageList.splice(i, 1)
      //   }
      // }

      filterDanmu.forEach(obj => {
        const talkInfo = obj.barrageSendInfo.replace(/{emoji:(\d+)}/gi, function(index) {
          // eslint-disable-next-line no-unused-vars
          const [num] = index.match(/\d+/g)
          const img = require(`@/assets/image/emoji/${num}.png`)
          // eslint-disable-next-line no-undef
          return `<img style="width:18px;height:18px;vertical-align: middle;" src=${img}>`
        })

        if (obj.userFace) {
          this.videoBullet.push(`
          <div class="bullet-item">
            <img src="${this.$isCdn(obj.userFace)}">
            <span style="color:${obj.barrageSendColor}">${obj.userName}:</span>
            <span style="color:${obj.barrageSendColor}">${talkInfo}</span>
          </div>`)
        } else {
          this.videoBullet.push(`
          <div class="bullet-item">
            <img src="${require('@/assets/image/user.png')}">
            <span style="color:${obj.barrageSendColor}">${obj.userName}:</span>
            <span style="color:${obj.barrageSendColor}">${talkInfo}</span>
          </div>`)
        }

        // this.liveBullet.push(`<span style="color:${element.barrageSendColor}">${element.barrageSendInfo}</span>`)
      })
    },
    handleHideMoreBtnDetail() {
      this.showMoreBtnDetail = false
    }
  },
  beforeDestroy() {
    this.$store.commit('closeFullScreen', false)
    this.$store.commit('setVideoDanmuSet', {
      isOpen: true,
      type: '1',
      attrId: ''
    })
    this.$store.commit('controlVideo', {isLive: true, liveisPlaying: false, videoisPlaying: false})
    this.$store.commit('controlPanel', {showDetail: false, showVideoSet: false, showRate: false})
    if (sessionStorage.getItem('isOpenDanmu')) {
      sessionStorage.removeItem('isOpenDanmu')
    }
    /* 关闭ws链接 */
    // this.$store.commit('initWs', null)
    // if (this.ws.close) {
    //   this.ws.close()
    // }
    // clearInterval(this.wsTime)
    this.liveDestroy()
  }
}
</script>

<style scoped lang="scss">
.play {
  height: 100vh;
  position: relative;
  overflow: hidden;
}
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.video-container {
  position: relative;
  height: 220px;
}
.fullScreen {
  position: absolute;
  z-index: 99;
  left: 0;
  top: 0;
  right: 0;
  height: 100vh;
  background: #000;
  video {
    object-fit: contain;
  }
}
.head {
  position: relative;
  height: 70px;
  display: flex;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  .person-select {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-shadow: 0px 0px 24px 0px rgba(21, 32, 80, 0.06);
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 12px;
    }
    span.txt {
      color: #303133;
      font-weight: 700;
    }
    i {
      position: absolute;
      right: 8px;
      top: 8px;
      color: #909399;
      font-size: 20px;
    }
  }
}
.head.subVideoActive {
  display: block;
  height: auto;
  .active-info-container {
    position: relative;
    width: 100%;
  }
  .sub-video-container {
    width: 100%;
    height: 220px;
  }
}
.active-info-container {
  position: relative;
  order: 1;
  flex: 1;
  padding: 8px 10px;
  width: 0;

  .title-container {
    position: relative;
    .title {
      color: #303133;
      font-weight: 800;
      padding-right: 48px;
    }
    .more-btn {
      position: absolute;
      right: 0;
      top: 2px;
      font-size: 14px;
      .more-btn-detail {
        z-index: 9;
        right: 100%;
        top: 0;
        width: 150px;
        padding: 10px;
        position: absolute;
        background: #fff;
        border-radius: 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.04);
      }
      span,
      i {
        color: #909399;

        vertical-align: middle;
      }
      small {
        margin-left: 4px;
      }
      i {
        font-size: 18px;
      }
    }
  }
  .tab {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .tab-container {
      span {
        padding-bottom: 6px;
        border-bottom: 3px solid transparent;
        margin-right: 20px;
        color: #606266;
      }
      span.active {
        border-bottom-color: #4465f3;
        color: #4465f3;
      }
    }
    .tab-right {
      display: flex;
      div {
        margin-left: 10px;
      }
      i,
      small {
        vertical-align: middle;
        color: #c0c4cc;
        font-size: 16px;
      }
      small {
        margin-left: 2px;
      }
    }
  }
}
.sub-video-container {
  order: 2;
  flex-shrink: 0;
  width: 130px;
  background: #606266;
  position: relative;
  .top-mask {
    position: absolute;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #000;
    color: #fff;
    font-size: 12px;
  }
}
.screen {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  height: 80%;
  // background: transparent;
}

.head.subVideoActive + .main-container {
  height: calc(100vh - 510px);
}
.main-container {
  height: calc(100vh - 290px - 50px);
  position: relative;
  .Notice {
    position: absolute;
    top: 1px;
    left: 0;
    width: 100%;
    // max-height: 260px;
    background: orange;
    overflow-y: auto;
    z-index: 9;
    padding: 10px 16px;
    i {
      position: absolute;
      right: 8px;
      top: 8px;
      color: #fff;
      font-size: 20px;
    }
    .value {
      word-break: break-all;
      color: #fff;
      font-size: 14px;
    }
    .title {
      margin-bottom: 10px;
      text-align: center;
      color: #fff;
    }
  }
}

#videoElement::-webkit-media-controls-enclosure {
  display: none !important;
  /*禁用播放器控制栏的样式*/
  /*;*/
}
</style>
<style lang="scss">
.bullet-item {
  display: flex;
  align-items: center;
  img {
    vertical-align: middle;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>
